export const N_OF_PHOTOS_BEGIN = 3;
export const N_OF_PHOTOS_END = 2;
